import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/** Keep saved links, readiness tabs and anchors working after the navigation move. */
export default function LegacyWarehouseRedirect({ type }) {
  const { id } = useParams();
  const { search, hash } = useLocation();
  const params = new URLSearchParams(search);
  let pathname = '/console/pipelines';
  if (type === 'index') {
    if (!['loads', 'preparation', 'storage'].includes(params.get('tab'))) params.set('tab', 'storage');
    params.delete('storage');
  }
  else if (type === 'new') pathname += '/storage/new';
  else pathname += `/${type}/${encodeURIComponent(id)}`;
  return <Navigate replace to={{ pathname, search: params.toString() ? `?${params}` : '', hash }} />;
}
